export const isNotProduction = () => process.env.NODE_ENV !== "production";
